export default __webpack_public_path__ + "static/media/gallery_06.68ca8726.jpg";